import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onChange"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { forwardRef } from 'react';
import { IMaskInput } from 'react-imask';
import { jsx as _jsx } from "react/jsx-runtime";
var TextMask = /*#__PURE__*/forwardRef(function (props, ref) {
  var onChange = props.onChange,
    restProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_jsx(IMaskInput, _objectSpread({
    onAccept: function onAccept(_, maskValue) {
      onChange(maskValue.unmaskedValue);
    },
    inputRef: function inputRef() {
      return ref;
    }
  }, restProps));
});
TextMask.displayName = 'TextMask';
export { TextMask };